import {
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { DealerMediaResponse } from '../services/client.service';
import { VideoPlayerService } from '../services/video-player.service';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VideoPlayerComponent } from '../video-player/video-player.component';
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TilesModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatExpansionModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
    VideoPlayerComponent,
  ],
})
export class CarouselComponent {
  @Input() id!: string;
  @Input() media: any;
  isEventInProgress: boolean = false;
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  activeSlideIndex: number = 0;
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @Input() isWalkthroughEnabled: boolean | undefined = false;
  @Input() introOutroMediaData!: DealerMediaResponse;

  constructor(
    private elementRef: ElementRef,
    private videoPlayerService: VideoPlayerService
  ) {}

  onCarouselSwipe(direction: 'left' | 'right', i: any) {
    this.videoPlayerService.clearActivePlayer();
    if (this.isEventInProgress) {
      return;
    }
    this.isEventInProgress = true;
    setTimeout(() => {
      if (this.videoElement) {
        this.videoElement.nativeElement.pause();
      }
      this.isEventInProgress = false;
      const items = this.elementRef.nativeElement.querySelectorAll(
        '.carousel-track-items' + i
      );
      const indicators = this.elementRef.nativeElement.querySelectorAll(
        '.indicators' + i
      );
      const itemCount = items.length;

      if (direction === 'right') {
        this.activeSlideIndex = this.activeSlideIndex - 1;

        if (0 > this.activeSlideIndex) {
          this.activeSlideIndex = itemCount - 1;
        }
      } else if (direction === 'left') {
        this.activeSlideIndex = this.activeSlideIndex + 1;
        if (this.activeSlideIndex >= itemCount) {
          this.activeSlideIndex = 0;
        }
      }

      this.updateActiveSlideClass(
        items,
        indicators,
        this.activeSlideIndex,
        direction
      );
    }, 1000);
  }

  private updateActiveSlideClass(
    items: NodeListOf<HTMLElement>,
    indicators: NodeListOf<HTMLElement>,
    activeIndex: number,
    direction: 'left' | 'right'
  ) {
    items.forEach((item, index) => {
      if (direction === 'right') {
        item.classList.remove('image-slide');
        item.classList.add('reverse');
      } else {
        item.classList.remove('reverse');
        item.classList.add('image-slide');
      }
      if (index === activeIndex) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    indicators.forEach((indicator, index) => {
      if (index === activeIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }

  updateActiveSlideIndex(i: number) {
    this.activeSlideIndex = i;
  }

  openMediaModal(imageUrl: string, altText: string) {
    this.modalImageUrl = imageUrl;
    this.modalImageAlt = altText;
    this.imageModal.nativeElement.style.display = 'block';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:block');
  }

  closeMediaModal() {
    this.videoPlayerService.clearActivePlayer();
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  isObjectEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 : true;
  }
}
